import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../Button/Button';
import { siteConfig } from '../../config/siteConfig';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
`;

const PopupContainer = styled.div`
  background-color: #f5f5f5;
  border-radius: 2px;
  padding: 1rem;
  max-width: 400px;
  width: 69%;
  max-height: 90%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
`;

const PopupImage = styled.img`
  width: 100%;
  max-width: 160px;
  height: auto;
  border-radius: 50%;
  margin: 0 auto;
  display: block;
  padding-bottom: 1rem;
`;

const Title = styled.h2`
  font-size: 1.25rem;
  color: #152437;
  font-weight: 700;
  text-align: center;
  margin-bottom: 1rem;
  max-width: 350px;
`;

const Message = styled.p`
  color: #152437;
  text-align: left;
  margin: 0.5rem 0;
`;

const MobilePopup: React.FC = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const isTouchScreen =
      'ontouchstart' in window || navigator.maxTouchPoints > 0;

    if (isTouchScreen || window.innerWidth <= 768) {
      setShowPopup(true);
    }
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      {showPopup && (
        <Overlay>
          <PopupContainer>
            <PopupImage src="/mobilepopupimage.png" alt="Popup Graphic" />
            <Title>
              <FormattedMessage
                id="mobilePopup.title"
                values={{ appName: siteConfig.appName }}
              />
            </Title>
            <Message>
              <FormattedMessage
                id="mobilePopup.messageLine1"
                values={{ appName: siteConfig.appName }}
              />
              <br />
              <br />
              <FormattedMessage
                id="mobilePopup.messageLine2"
                values={{ appName: siteConfig.appName }}
              />
            </Message>
            <Button onClick={closePopup}>
              <FormattedMessage id="mobilePopup.closeButton" />
            </Button>
          </PopupContainer>
        </Overlay>
      )}
    </>
  );
};

export default MobilePopup;
